export default __webpack_public_path__ + "static/media/icon-search-white.ca3f49e1.svg";